import { Navbar, Container, Nav } from "react-bootstrap";
import { useState, useRef, useEffect, useContext } from "react";
import logo from "../../assets/icons/NWR_logo_colored.svg";
import lightLogo from "../../assets/icons/NWR_logo_light.svg";
// import logo from "../../assets/images/Logo.svg";
import notificationIcon from "../../assets/images/Notification-icon.svg";
import "./navbar.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import AdminMenuList from "./Components/AdminMenuList";
import MobileProfileMenu from "./Components/MobileProfileMenu";
import profileIcon from "../../assets/icons/profile-icon.svg";
import headerSearchIcon from "../../assets/icons/headerSearch.svg";
import searchIcon from "./../../assets/icons/ic_sharp-search.svg";
import menuIcon from "../../assets/icons/MenuIcon.svg";
import { useUserProfile } from "../../auth.user";
import { useUserCapabilities } from "../../auth.capabilities";
import { Image } from "react-bootstrap";
import { useNotifications } from "../../hooks/useNotifications";
import { folderAPICategories } from "../../utils/apisConstants";
import { ThemeContext } from "../../context/themeContext";

const NavbarComponent = () => {
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showMobileNotifications, setShowMobileNotifications] = useState(false);
  const [mobileNotificationsTop, setMobileNotificationsTop] = useState(0);
  const notifRef = useRef(null);
  const mobileNotifRef = useRef(null);
  const mobileNotifButtonRef = useRef(null);
  const {
    notifications,
    unreadCount,
    loading: notifLoading,
    markAsRead,
    markAllAsRead,
    removeNotification,
    clearAll,
  } = useNotifications();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target))
        setShowNotifications(false);
      if (mobileNotifRef.current && !mobileNotifRef.current.contains(e.target))
        setShowMobileNotifications(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (!showMobileNotifications) return undefined;

    const updateMobileNotificationPosition = () => {
      const trigger = mobileNotifButtonRef.current;
      if (!trigger) return;

      const rect = trigger.getBoundingClientRect();
      setMobileNotificationsTop(Math.round(rect.bottom + 12));
    };

    updateMobileNotificationPosition();
    window.addEventListener("resize", updateMobileNotificationPosition);
    window.addEventListener("orientationchange", updateMobileNotificationPosition);

    return () => {
      window.removeEventListener("resize", updateMobileNotificationPosition);
      window.removeEventListener(
        "orientationchange",
        updateMobileNotificationPosition,
      );
    };
  }, [showMobileNotifications]);
  const location = useLocation();

  const navigate = useNavigate();
  // const [isHoveringForYou, setIsHoveringForYou] = useState(false);
  const { profile, loading } = useUserProfile();
  const { hasAdminRights, hasInternalUserRights, hasExternalUserRights } =
    useUserCapabilities();
  const { isDarkMode } = useContext(ThemeContext);

  const userAvatar =
    !loading && profile?.photoUrl ? profile.photoUrl : profileIcon;
  const isDefaultAvatar = userAvatar === profileIcon;
  const brandLogo = isDarkMode ? lightLogo : logo;

  const forceLeaveNewStandard = (event, path) => {
    if (location.pathname !== "/new-standard") return;
    event.preventDefault();
    window.location.assign(path);
  };

  const handleNavSearchClick = (e) => {
    // If already on searched page → do nothing
    if (location.pathname === "/searchedPage") {
      e.preventDefault();
      return;
    }
    // Otherwise, navigate normally
    navigate("/searchedPage");
  };

  return (
    <>
      <Navbar expand="lg" collapseOnSelect className="navbar-wrapper">
        <Container fluid className="container-wrapper">
          <NavLink to={"/"}>
            <Navbar.Brand className="d-flex align-items-center">
              <img src={brandLogo} alt="NWR" width={120} height={50} />
            </Navbar.Brand>
          </NavLink>
          {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}

          <Navbar.Collapse id="responsive-navbar-nav">
            {/* Center navigation: stacked on small screens, horizontal from lg */}
            <Nav className="d-flex flex-column flex-lg-row align-items-center mx-auto w-70 center-nav">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `font-bold ${isActive ? "active" : ""}`
                }
                onClick={(event) => forceLeaveNewStandard(event, "/")}
              >
                Home
              </NavLink>
              <NavLink
                to={`/standards-category-specific?cid=${folderAPICategories.steeringGroups}`}
                className={({ isActive }) =>
                  `font-bold ${isActive ? "active" : ""}`
                }
                onClick={(event) =>
                  forceLeaveNewStandard(
                    event,
                    `/standards-category-specific?cid=${folderAPICategories.steeringGroups}`,
                  )
                }
              >
                Steering Groups
              </NavLink>
              <NavLink
                to="/about-us"
                className={({ isActive }) =>
                  `font-bold ${isActive ? "active" : ""}`
                }
                onClick={(event) => forceLeaveNewStandard(event, "/about-us")}
              >
                About Us
              </NavLink>
              <NavLink
                to="/challenge"
                className={({ isActive }) =>
                  `font-bold ${isActive ? "active" : ""}`
                }
                onClick={(event) => forceLeaveNewStandard(event, "/challenge")}
              >
                Challenge
              </NavLink>
              <NavLink
                to="/faq"
                className={({ isActive }) =>
                  `font-bold ${isActive ? "active" : ""}`
                }
                onClick={(event) => forceLeaveNewStandard(event, "/faq")}
              >
                FAQ
              </NavLink>
              <NavLink
                to="/reports"
                className={({ isActive }) =>
                  `font-bold ${isActive ? "active" : ""}`
                }
                onClick={(event) => forceLeaveNewStandard(event, "/reports")}
              >
                Reports
              </NavLink>
            </Nav>

            <Nav className="d-flex flex-column flex-lg-row align-items-center ms-lg-auto w-30">
              <div className="notification-and">
                <NavLink
                  to="/searchedPage"
                  onClick={handleNavSearchClick}
                  className="notification-button"
                  aria-label="Search"
                >
                  <div className="search">
                    <img className="icon" src={headerSearchIcon} alt="search" />
                  </div>
                </NavLink>

                <NavLink
                  to="/help-centre"
                  className="notification-button"
                  aria-label="Help Centre"
                  title="Help Centre"
                >
                  <div className="notification help-centre-action-icon">
                    <span aria-hidden="true">?</span>
                  </div>
                </NavLink>

                <div className="notif-wrap" ref={notifRef}>
                  <button
                    className="notification-button"
                    onClick={() => setShowNotifications((v) => !v)}
                    aria-label="Notifications"
                  >
                    <div className="notification">
                      <img
                        className="icon"
                        src={notificationIcon}
                        alt="Notifications"
                      />
                      {unreadCount > 0 && (
                        <span className="notif-badge">
                          {unreadCount > 99 ? "99+" : unreadCount}
                        </span>
                      )}
                    </div>
                  </button>

                  {showNotifications && (
                    <div className="notif-dropdown">
                      <div className="notif-header">
                        <span>Notifications</span>
                        <div className="notif-header-actions">
                          {unreadCount > 0 && (
                            <button
                              className="notif-mark-all"
                              onClick={markAllAsRead}
                            >
                              Mark all read
                            </button>
                          )}
                          {notifications.length > 0 && (
                            <button
                              className="notif-clear-all"
                              onClick={() => {
                                if (
                                  window.confirm(
                                    "Clear all notifications? This cannot be undone.",
                                  )
                                ) {
                                  clearAll();
                                }
                              }}
                            >
                              Clear all
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="notif-list">
                        {notifLoading ? (
                          <p className="notif-empty">Loading…</p>
                        ) : notifications.length === 0 ? (
                          <p className="notif-empty">No notifications</p>
                        ) : (
                          notifications.map((n) => {
                            // SearchAPI appends the destination URL to the notification message.
                            // Strip ALL URLs from the displayed text and use the last one for the
                            // "View →" click target. Defensive against duplicate URLs / odd whitespace.
                            const urlsFound =
                              (n.message || "").match(/(https?:\/\/\S+)/g) ||
                              [];
                            const lastUrl = urlsFound.length
                              ? urlsFound[urlsFound.length - 1]
                              : null;
                            let notifLink = null;
                            if (lastUrl) {
                              try {
                                const u = new URL(lastUrl);
                                notifLink = u.pathname + u.search;
                              } catch {
                                notifLink = null;
                              }
                            }
                            const cleanMessage = (n.message || "")
                              .replace(/(https?:\/\/\S+)/g, "")
                              .replace(/\s+/g, " ")
                              .trim();
                            return (
                              <div
                                key={n.id}
                                className={`notif-item ${n.isRead ? "" : "notif-unread"}`}
                              >
                                <div
                                  className="notif-content"
                                  style={{
                                    cursor: notifLink ? "pointer" : "default",
                                  }}
                                  onClick={() => {
                                    if (!n.isRead) markAsRead(n.id);
                                    if (notifLink) {
                                      setShowNotifications(false);
                                      navigate(notifLink);
                                    }
                                  }}
                                >
                                  <p className="notif-title">{n.title}</p>
                                  <p className="notif-msg">
                                    {cleanMessage}
                                    {notifLink && (
                                      <span
                                        style={{
                                          marginLeft: "6px",
                                          color: "var(--accent-color)",
                                          fontSize: "0.8rem",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        View →
                                      </span>
                                    )}
                                  </p>
                                  <p className="notif-time">
                                    {new Date(n.createdAt).toLocaleDateString(
                                      "en-GB",
                                    )}
                                  </p>
                                </div>
                                <button
                                  className="notif-delete"
                                  onClick={() => removeNotification(n.id)}
                                >
                                  ✕
                                </button>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <AdminMenuList />
              </div>
              {/* <Nav.Link href="#sign-up" className="font-bold">
              <Button className="btn btn-sm signup-button">Sign Up</Button>
            </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>

          {/* MOBILE ICONS ONLY */}
          <div className="mobile-actions d-lg-none">
            <NavLink
              to="/searchedPage"
              onClick={handleNavSearchClick}
              className="icon-btn"
              aria-label="Search"
            >
              <img className="icon-svg" src={searchIcon} alt="search" />
            </NavLink>

            <NavLink
              to="/help-centre"
              className="icon-btn mobile-help-centre-action"
              aria-label="Help Centre"
              title="Help Centre"
            >
              <span aria-hidden="true">?</span>
            </NavLink>

            <div className="notif-wrap" ref={mobileNotifRef}>
              <button
                className="icon-btn"
                aria-label="Notifications"
                ref={mobileNotifButtonRef}
                style={{ position: "relative" }}
                onClick={(event) => {
                  const nextOpen = !showMobileNotifications;
                  if (nextOpen) {
                    setMobileNotificationsTop(
                      Math.round(event.currentTarget.getBoundingClientRect().bottom + 12),
                    );
                  }
                  setShowMobileNotifications(nextOpen);
                  setShowMobileNav(false);
                  setShowProfileMenu(false);
                }}
              >
                <img
                  className="icon-svg"
                  src={notificationIcon}
                  alt="Notifications"
                />
                {unreadCount > 0 && (
                  <span className="notif-badge" style={{ top: "-4px", right: "-4px" }}>
                    {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
                )}
              </button>

              {showMobileNotifications && (
                <div
                  className="notif-dropdown"
                  style={{
                    position: "fixed",
                    top: `${mobileNotificationsTop}px`,
                    left: "50%",
                    right: "auto",
                    transform: "translateX(-50%)",
                    width: "min(320px, calc(100vw - 32px))",
                    maxWidth: "calc(100vw - 32px)",
                    background: "var(--bg-dropdown-menu)",
                    border: "1px solid var(--border-colour)",
                    borderRadius: "12px",
                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
                    zIndex: 9999,
                    overflow: "hidden",
                    padding: "12px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", paddingBottom: "4px" }}>
                    <span style={{ fontSize: "14px", fontWeight: "600", color: "var(--primary-text-color)" }}>Notifications</span>
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                      {unreadCount > 0 && (
                        <button
                          style={{ fontSize: "11px", color: "var(--accent-color)", background: "none", border: "none", textDecoration: "underline", padding: 0 }}
                          onClick={(e) => { e.stopPropagation(); markAllAsRead(); }}
                        >
                          Mark read
                        </button>
                      )}
                      {notifications.length > 0 && (
                        <button
                          style={{ fontSize: "11px", color: "var(--accent-color)", background: "none", border: "none", textDecoration: "underline", padding: 0 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (window.confirm("Clear all notifications?")) {
                              clearAll();
                            }
                          }}
                        >
                          Clear
                        </button>
                      )}
                    </div>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%", maxHeight: "196px", overflowY: "auto", paddingRight: "2px" }}>
                    {notifLoading ? (
                      <p style={{ textAlign: "center", color: "var(--text-muted-color)", fontSize: "11px", margin: "10px 0" }}>Loading…</p>
                    ) : notifications.length === 0 ? (
                      <p style={{ textAlign: "center", color: "var(--text-muted-color)", fontSize: "11px", margin: "10px 0" }}>No notifications</p>
                    ) : (
                      notifications.map((n) => {
                        const urlsFound = (n.message || "").match(/(https?:\/\/\S+)/g) || [];
                        const lastUrl = urlsFound.length ? urlsFound[urlsFound.length - 1] : null;
                        let notifLink = null;
                        if (lastUrl) {
                          try {
                            const u = new URL(lastUrl);
                            notifLink = u.pathname + u.search;
                          } catch {
                            notifLink = null;
                          }
                        }
                        const cleanMessage = (n.message || "")
                          .replace(/(https?:\/\/\S+)/g, "")
                          .replace(/\s+/g, " ")
                          .trim();
                        return (
                          <div
                            key={n.id}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "6px",
                              padding: "8px 10px",
                              background: "var(--bg-secondary-surface)",
                              border: "1px solid var(--border-colour)",
                              borderRadius: "8px",
                              cursor: "pointer",
                              borderLeft: n.isRead ? "1px solid var(--border-colour)" : "3px solid var(--text-heading)",
                            }}
                          >
                            <div
                              style={{ flex: 1 }}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (!n.isRead) markAsRead(n.id);
                                if (notifLink) {
                                  setShowMobileNotifications(false);
                                  navigate(notifLink);
                                }
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  margin: "0 0 2px",
                                  color: "var(--primary-text-color)",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 1,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  lineBreak: "anywhere",
                                }}
                              >
                                {n.title}
                              </p>
                              <p
                                style={{
                                  fontSize: "10px",
                                  margin: "0 0 4px",
                                  color: "var(--text-secondary-color)",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  lineBreak: "anywhere",
                                }}
                              >
                                {cleanMessage}
                                {notifLink && (
                                  <span style={{ marginLeft: "4px", color: "var(--accent-color)", fontWeight: "600" }}>View →</span>
                                )}
                              </p>
                              <p style={{ fontSize: "9px", color: "var(--text-muted-color)", margin: 0 }}>
                                {new Date(n.createdAt).toLocaleDateString("en-GB")}
                              </p>
                            </div>
                            <button
                              onClick={(e) => { e.stopPropagation(); removeNotification(n.id); }}
                              style={{ background: "none", border: "none", color: "var(--text-muted-color)", fontSize: "10px", padding: "0 2px" }}
                            >
                              ✕
                            </button>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* USER AVATAR */}
            <button
              className="icon-btn "
              onClick={() => {
                setShowProfileMenu(true);
                setShowMobileNav(false);
              }}
            >
              <Image
                className={`avatar-img ${isDefaultAvatar ? "default-avatar" : ""}`}
                src={userAvatar}
                alt="User"
                roundedCircle
                width={28}
                height={28}
              />
            </button>

            {/* BURGER */}
            <button
              className="icon-btn "
              onClick={() => {
                setShowMobileNav(true);
                setShowProfileMenu(false);
              }}
            >
              <img className="icon-svg" src={menuIcon} alt="Menu" />
            </button>
          </div>
        </Container>
      </Navbar>

      {/* MOBILE NAV OVERLAY */}
      {showMobileNav && (
        <div className="mobile-overlay">
          <button className="close-btn" onClick={() => setShowMobileNav(false)}>
            ✕
          </button>

          <Nav className="mobile-nav">
            {[
              ["/", "Home"],
              [
                `/standards-category-specific?cid=${folderAPICategories.steeringGroups}`,
                "Steering Groups",
              ],
              ["/about-us", "About Us"],
              ["/challenge", "Challenge"],
              ["/faq", "FAQ"],
              ["/reports", "Reports"],
            ].map(([path, label]) => (
              <NavLink
                key={path}
                to={path}
                className="mobile-link"
                onClick={() => setShowMobileNav(false)}
              >
                {label}
              </NavLink>
            ))}
          </Nav>
        </div>
      )}

      {/*MOBILE PROFILE OVERLAY */}
      {showProfileMenu && (
        <div className="mobile-overlay">
          <button
            className="close-btn"
            onClick={() => setShowProfileMenu(false)}
          >
            ✕
          </button>

          <MobileProfileMenu onClose={() => setShowProfileMenu(false)} />
        </div>
      )}
    </>
  );
};

export default NavbarComponent;
